import React from 'react';
import { useQuery } from 'react-apollo';
import { Redirect } from 'react-router';
import productByArticlenumberQuery from './ProductByArticlenumber.gql';
import encodeVariantValues from '@jetshop/core/helpers/encodeVariant';
const ProductByArticlenumber = ({ articleNumber }) => {
    var _a, _b;
    const { data, loading } = useQuery(productByArticlenumberQuery, {
        variables: { articleNumber },
        errorPolicy: 'all'
    });
    if (loading) {
        return null;
    }
    const product = data === null || data === void 0 ? void 0 : data.product;
    const variant = (product === null || product === void 0 ? void 0 : product.hasVariants) &&
        product.variants.values.find(variant => variant.articleNumber === articleNumber);
    const encoding = variant ? encodeVariantValues(variant) : '';
    return (data === null || data === void 0 ? void 0 : data.product) ? (React.createElement(Redirect, { to: `${((_b = (_a = data === null || data === void 0 ? void 0 : data.product) === null || _a === void 0 ? void 0 : _a.primaryRoute) === null || _b === void 0 ? void 0 : _b.path) + encoding}` })) : (React.createElement(Redirect, { to: "/" }));
};
export default ProductByArticlenumber;
//# sourceMappingURL=ProductByArticlenumber.js.map